import type { ReactNode } from "react";
import { trackEvent } from "../../services/firebase";
import arrowRight from "../../assets/home/icon-arrow-right.svg";

// eslint-disable-next-line react-refresh/only-export-components
export const APPLY_LINK = import.meta.env.VITE_WEBSITE_LINK;

export function SectionBadge({ children }: { children: ReactNode }) {
  return (
    <span className="inline-flex bg-[#ecfdf5] px-4 py-1.5 rounded-full font-black text-[#10b981] text-[11px] sm:text-[12px] tracking-[2px] uppercase whitespace-nowrap">
      {children}
    </span>
  );
}

export function SectionHeader({
  badge,
  title,
  subtitle,
  align = "center",
}: {
  badge: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  align?: "center" | "left";
}) {
  const alignCls = align === "center" ? "items-center text-center" : "items-start text-left";
  return (
    <div className={`flex flex-col gap-4 w-full ${alignCls}`}>
      <SectionBadge>{badge}</SectionBadge>
      <h2 className="font-bold text-[#1a1a4b] text-[28px] sm:text-[40px] leading-[1.2] sm:leading-[48px] tracking-[-1px]">
        {title}
      </h2>
      {subtitle && (
        <p className={`font-medium text-[#6a7282] text-[15px] sm:text-[16px] leading-[24px] ${align === "center" ? "max-w-[680px]" : ""}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
}

export function ApplyButton({
  label,
  location,
  href = APPLY_LINK,
  arrow = true,
  className = "",
}: {
  label: string;
  location: string;
  href?: string;
  arrow?: boolean;
  className?: string;
}) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackEvent("apply_now_click", { location })}
      className={`inline-flex items-center justify-center gap-2 bg-[#5c168a] rounded-full font-bold text-[14px] text-white tracking-[1px] uppercase whitespace-nowrap transition-opacity hover:opacity-90 ${className}`}
    >
      {label}
      {arrow && <img src={arrowRight} alt="" className="size-[14px]" />}
    </a>
  );
}

export function IconCircle({ size, className = "", children }: { size: number; className?: string; children: ReactNode }) {
  return (
    <span
      className={`inline-flex items-center justify-center shrink-0 rounded-full bg-[#f8eeff] ${className}`}
      style={{ width: size, height: size }}
    >
      {children}
    </span>
  );
}
